module.exports = "<md-dialog style=\"padding: 12px;\" layout=\"column\">\n    <md-dialog-content layout=\"column\" layout-align=\"center center\" style=\"text-align: center;\">\n        <h2 class=\"md-title\">Something went wrong</h2>\n        <p>Your schedule is out of sync</p>\n        <p>Auto-reloading in 10s</p>\n    </md-dialog-content>\n    <md-dialog-actions>\n        <md-button class=\"md-primary\" ng-click=\"$ctrl.reload()\">Reload now</md-button>\n    </md-dialog-actions>\n</md-dialog>"


//////////////////
// WEBPACK FOOTER
// ./routes/feiseanna/one/admin/schedule/sync-error-dialog.html
// module id = 1206
// module chunks = 0